import { useTranslation } from '@/services/i18n'

import React, { memo } from 'react'
import styles from '../AvatarUser/AvatarUser.module.scss'
import ResizeImage from '../ResizeImage/ResizeImage'
interface ChildProps {
  avatar: string
  name: string
  isDeleted?: boolean
}
const AvatarUser = memo<ChildProps>(props => {
  const { avatar, name, isDeleted } = props
  const { t } = useTranslation()
  return (
    <div className={styles.avatar_user}>
      <ResizeImage src={avatar} size="24x24" />
      <span>{name}</span>
      {isDeleted && <span>({t('common.delete1')})</span>}
    </div>
  )
})

export default AvatarUser
